"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBoxSubDocumentExporter = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var fixed_1 = require("@devexpress/utils/lib/intervals/fixed");
var base_sub_document_1 = require("./base-sub-document");
var TextBoxSubDocumentExporter = (function (_super) {
    tslib_1.__extends(TextBoxSubDocumentExporter, _super);
    function TextBoxSubDocumentExporter(data, subDocument) {
        return _super.call(this, data, subDocument, '') || this;
    }
    Object.defineProperty(TextBoxSubDocumentExporter.prototype, "rootElement", {
        get: function () { throw new Error(errors_1.Errors.NotImplemented); },
        enumerable: false,
        configurable: true
    });
    TextBoxSubDocumentExporter.prototype.exportTextBoxContent = function () {
        this.data.subDocumentExporterStack.push(this);
        this.fillWriterCore();
        this.data.subDocumentExporterStack.pop();
    };
    TextBoxSubDocumentExporter.prototype.createRelationExporter = function () { throw new Error(errors_1.Errors.NotImplemented); };
    TextBoxSubDocumentExporter.prototype.fillWriter = function () { throw new Error(errors_1.Errors.NotImplemented); };
    TextBoxSubDocumentExporter.prototype.fillWriterCore = function () {
        this.init();
        this.exportSection(this.data.model.sections[0], new fixed_1.FixedInterval(0, this.subDocument.getDocumentEndPosition()));
    };
    return TextBoxSubDocumentExporter;
}(base_sub_document_1.BaseSubDocumentExporter));
exports.TextBoxSubDocumentExporter = TextBoxSubDocumentExporter;
